import React from "react";
import Tile from "@src/components/containers/Tile";
import Tabs from "@src/components/common/Tabs";
import { Tab } from "@src/components/common/Tabs/Tabs";
import AccountGeneralSettings from "@src/components/widgets/AccountGeneralSettings";
import AccountSecuritySettings from "@src/components/widgets/AccountSecuritySettings";
import AccountNotificationSettings from "@src/components/widgets/AccountNotificationSettings";
import AccountDistributorSettings from "@src/components/widgets/AccountDistributorSettings";
// Note: Commented out for Beta - payment methods removed, distributors will be invoicing to start
// import AccountPaymentMethodSettings from "@src/components/widgets/AccountPaymentMethodSettings";
import AccountHiddenItemSettings from "@src/components/widgets/AccountHiddenItemSettings";
import { useParams, useNavigate } from "react-router-dom";
import { getHasPermission } from "@src/utils/permission";
import PermissionLevels from "@src/constants/PermissionLevels";
import { useCurrentUserStore } from "@src/state/currentUserState";
import Permissions from "@src/constants/Permissions";

const TABS: Tab[] = [
  {
    key: "general",
    label: "General",
    content: <AccountGeneralSettings />,
    "data-testid": "account-tab-general",
  },
  {
    key: "security",
    label: "Security",
    content: <AccountSecuritySettings />,
    "data-testid": "account-tab-security",
  },
  {
    key: "notifications",
    label: "Notifications",
    content: <AccountNotificationSettings />,
    "data-testid": "account-tab-notifications",
  },
];

function AccountPage(): React.JSX.Element {
  const { view } = useParams<{ view?: string }>();
  const navigate = useNavigate();
  const { currentUser } = useCurrentUserStore();

  const userPermissionedTabs = [...TABS];
  if (
    !!currentUser &&
    getHasPermission(
      currentUser,
      Permissions.Distributors,
      PermissionLevels.View,
    )
  ) {
    userPermissionedTabs.push({
      key: "distributors",
      label: "Distributors",
      content: <AccountDistributorSettings />,
      "data-testid": "account-tab-distributors",
    });
  }
  if (
    !!currentUser &&
    getHasPermission(
      currentUser,
      Permissions.Products,
      PermissionLevels.View,
    ) &&
    getHasPermission(
      currentUser,
      Permissions.Manufacturers,
      PermissionLevels.View,
    )
  ) {
    userPermissionedTabs.push({
      key: "hidden-items",
      label: "Hidden Items",
      content: <AccountHiddenItemSettings />,
      "data-testid": "account-tab-hidden-items",
    });
  }

  return (
    <>
      <Tile>
        <div className="text-xl font-weight-bold padding-bottom-xl">
          Account Settings
        </div>

        <Tabs
          tabs={userPermissionedTabs}
          selectedTabKey={view || userPermissionedTabs[0].key}
          onTabChange={(view: string) => navigate(`/account/${view}`)}
        />
      </Tile>
    </>
  );
}

export default AccountPage;
